import ServerErrorModal from './server-error-modal';

export default ServerErrorModal;
